function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react/no-unused-prop-types */
import '../Charts.scss';
import * as d3 from 'd3';
import React, { Component } from 'react';
import { AVIChartTile } from '../../Layout/AVIChartTile/AVIChartTile';
import { BaseMixin } from '../Mixins/BaseMixin';
import { ColorMixin } from '../Mixins/ColorMixin';
import { CoordinateGridMixin } from '../Mixins/CoordinateGridMixin';
import { MarginsMixin } from '../Mixins/MarginsMixin';
import PropTypes from 'prop-types';
import { TileMixin } from '../Mixins/TileMixin';
import dc from 'dc';
export var RowChartStacked = /*#__PURE__*/function (_Component) {
  _inheritsLoose(RowChartStacked, _Component);

  function RowChartStacked(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.chartRef = React.createRef();
    _this.getChart = _this.getChart.bind(_assertThisInitialized(_this));
    _this.chart = _this.createChart.bind(_assertThisInitialized(_this));
    _this.state = {
      chart: null
    };
    return _this;
  }

  var _proto = RowChartStacked.prototype;

  _proto.createChart = function createChart(parent, chartGroup) {
    var _this$props = this.props,
        gap = _this$props.gap,
        stackOrder = _this$props.stackOrder,
        subStackOrder = _this$props.subStackOrder,
        showLegend = _this$props.showLegend,
        labelNumberFormat = _this$props.labelNumberFormat;

    var _chart = dc.coordinateGridMixin(dc.marginMixin(dc.colorMixin(dc.baseMixin({}))));

    var _g = null;
    var _gap = gap;

    _chart.gap = function (gap) {
      if (typeof gap === 'number') {
        _gap = gap;
        return _chart;
      }

      return _gap;
    };

    var _subStackOrder = subStackOrder;

    _chart.subStackOrder = function (subStackOrder) {
      if (typeof subStackOrder === 'function') {
        _subStackOrder = subStackOrder;
        return _chart;
      }

      return _subStackOrder;
    };

    var _stackOrder = stackOrder;

    _chart.stackOrder = function (stackOrder) {
      if (typeof stackOrder === 'function') {
        _stackOrder = stackOrder;
        return _chart;
      }

      return _stackOrder;
    };

    var _showLegend = showLegend;

    _chart.showLegend = function (showLegend) {
      if (showLegend !== undefined) {
        _showLegend = showLegend;
        return _chart;
      }

      return _showLegend;
    };

    _chart.legendables = function () {
      var uniqueEntries = Array.from(new Set(_chart.data().map(function (d) {
        return d.key[1];
      }))).sort(subStackOrder);
      return uniqueEntries.map(function (d) {
        return {
          name: d,
          data: d,
          chart: _chart,
          color: _chart.colors()(d)
        };
      });
    };

    _chart.legendHighlight = function (d) {};

    _chart.legendReset = function (d) {};

    _chart.legendToggle = function (d) {// this.onClick({ key: d.name, others: d.others });
    };

    _chart._draw = function () {
      // Calculate margins, widths and setup SVG
      var hMargin = _chart.margins().left + _chart.margins().right;

      var vMargin = _chart.margins().top + _chart.margins().bottom;

      var xWidth = _chart.width() - hMargin;
      var yHeight = _chart.height() - vMargin;

      _chart.resetSvg();

      _g = _chart.svg().append('g').attr('transform', 'translate(' + _chart.margins().left + ',' + _chart.margins().top + ')').attr('class', 'row-chart-stacked'); // Extract data from, reshape and sort group

      var _group = _chart.group().all().slice(0);

      var stackKeys = Array.from(new Set(_group.map(function (d) {
        return d.key[0];
      })));
      var subStackKeys = Array.from(new Set(_group.map(function (d) {
        return d.key[1];
      })));
      var reshapedData = [];
      stackKeys.forEach(function (s) {
        var row = {};
        var rowTotal = 0;
        subStackKeys.forEach(function (ss, ssIdx, arr) {
          row._key_ = s;
          row[ss] = _group.filter(function (d) {
            return d.key[0] === s && d.key[1] === ss;
          }).map(function (d) {
            return d.value;
          })[0] || 0;
          rowTotal += row[ss];
        });
        row.total = rowTotal;
        reshapedData.push(row);
      });
      reshapedData.sort(function (a, b) {
        return b.total - a.total;
      }); // Get keys and create corresponding axis

      var sortedStackKeys = reshapedData.map(function (r) {
        return r._key_;
      }).sort(_chart.stackOrder());
      var sortedSubStackKeys = subStackKeys.sort(_chart.subStackOrder());

      _chart.y(d3.scaleBand().rangeRound([0, yHeight]).paddingInner(_chart.gap()).align(0.1).domain(sortedStackKeys));

      _chart.x(d3.scaleLinear().rangeRound([0, xWidth]).domain([0, d3.max(reshapedData.map(function (d) {
        return d.total;
      }))]).nice());

      _chart.colors();

      var stackedData = d3.stack().keys(sortedSubStackKeys)(reshapedData);
      stackedData.forEach(function (sd, i, a) {
        sd.forEach(function (sdd) {
          sdd._subKey_ = '' + sd.key;
        });
      });

      _g.append('g').selectAll('g').data(stackedData).enter().append('g').attr('fill', function (d) {
        return _chart.colors()(d.key);
      }).attr('class', function (d) {
        return d.key;
      }).selectAll('rect').data(function (d) {
        return d;
      }).enter().append('rect').attr('y', function (d) {
        return _chart.y()(d.data._key_);
      }).attr('x', function (d) {
        return _chart.x()(d[0]);
      }).attr('width', function (d) {
        return _chart.x()(d[1]) - _chart.x()(d[0]);
      }).attr('height', _chart.y().bandwidth()); // .attr('height', _chart.y().bandwidth() - _chart.gap());
      // Append click event to rect


      _g.selectAll('g').selectAll('g').selectAll('rect').on('click', function (evt) {
        _chart.filter([evt.data._key_, evt._subKey_]);

        dc.redrawAll();
      }); // Append title (mouse over)


      _g.selectAll('g').selectAll('g').selectAll('rect').append('title').text(function (d) {
        return d.data._key_ + '/' + d._subKey_ + ': ' + labelNumberFormat(d[1] - d[0]);
      }); // Append axis


      _g.append('g').attr('class', 'axis y').attr('transform', 'translate(0,0)').call(d3.axisLeft(_chart.y()));

      _g.append('g').attr('class', 'axis x').attr('transform', 'translate(0,' + yHeight + ')').call(d3.axisBottom(_chart.x()).ticks(10)).append('text').attr('y', 2).attr('x', _chart.x()(_chart.x().ticks().pop()) + 0.5).attr('dy', '0.32em').attr('fill', '#000').attr('font-weight', 'bold').attr('text-anchor', 'center').text('Population').attr('transform', 'translate(' + -(xWidth / 2) + ',30)');
    };

    _chart._doRender = function () {
      _chart._draw();
    };

    _chart._doRedraw = function () {
      _chart._draw();
    };

    return _chart.anchor(parent, chartGroup);
  };

  _proto.componentDidMount = function componentDidMount() {
    var _this$props2 = this.props,
        renderLabel = _this$props2.renderLabel,
        renderTitle = _this$props2.renderTitle,
        valueAccessor = _this$props2.valueAccessor,
        stackOrder = _this$props2.stackOrder,
        subStackOrder = _this$props2.subStackOrder,
        gap = _this$props2.gap,
        showLegend = _this$props2.showLegend,
        legendCols = _this$props2.legendCols,
        legendHeight = _this$props2.legendHeight,
        legendItemHeight = _this$props2.legendItemHeight,
        legendItemGap = _this$props2.legendItemGap,
        legendItemSymbol = _this$props2.legendItemSymbol;
    var chart = this.createChart(this.chartRef.current); // Set mixin properties

    BaseMixin(chart, this.props);
    ColorMixin(chart, this.props);
    MarginsMixin(chart, this.props);
    CoordinateGridMixin(chart, this.props);
    TileMixin(chart, this.props); // Set custom properties

    chart.renderLabel(renderLabel).renderTitle(renderTitle).valueAccessor(valueAccessor).stackOrder(stackOrder).subStackOrder(subStackOrder).gap(gap).showLegend(showLegend);

    if (showLegend) {
      chart.margins().bottom += legendHeight + legendItemGap;
      chart.legend(dc.legend().x(chart.margins().left).y(chart.height() - legendHeight).horizontal(true).legendWidth(chart.width() - (chart.margins().left + chart.margins().right)).itemWidth((chart.width() - (chart.margins().left + chart.margins().right)) / legendCols).itemHeight(legendItemHeight).gap(legendItemGap).legendText(function (d) {
        return d.name;
      }));

      if (legendItemSymbol === 'circle') {
        chart.on('pretransition', function (chart) {
          var legendItem = chart.selectAll('.dc-legend-item');
          var legendSymbol = legendItem.select('rect');
          legendSymbol.remove();
          legendItem.insert('circle', ':first-child').attr('cy', 8).attr('r', 8).attr('fill', function (d) {
            return d.color;
          });
        });
      }
    } // Render chart


    chart.render();
    this.setState({
      chart: chart
    });
  };

  _proto.getChart = function getChart() {
    var chart = this.state.chart;
    return chart;
  };

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(AVIChartTile, {
      title: this.props.chartTitle,
      getChart: this.getChart,
      showTools: this.props.showTools,
      toolsComponent: this.props.toolsComponent
    }, /*#__PURE__*/React.createElement("div", {
      className: "avi-chart chart tree-map",
      ref: this.chartRef
    }));
  };

  return RowChartStacked;
}(Component);

_defineProperty(RowChartStacked, "defaultProps", {
  width: 640,
  height: 480,
  renderLabel: true,
  renderTitle: true,
  valueAccessor: function valueAccessor(d) {
    return d.value;
  },
  margins: {
    left: 50,
    top: 5,
    right: 5,
    bottom: 40
  },
  gap: 0.15,
  showSVGLegend: false,
  showHtmlLegend: false,
  legendCols: 3,
  legendHeight: 75,
  legendItemHeight: 15,
  legendItemGap: 10,
  legendItemSymbol: 'rect',
  stackOrder: function stackOrder(a, b) {
    if (a > b) {
      return -1;
    } else if (b > a) {
      return 1;
    } else {
      return 0;
    }
  },
  subStackOrder: function subStackOrder(a, b) {
    if (a > b) {
      return -1;
    } else if (b > a) {
      return 1;
    } else {
      return 0;
    }
  },
  labelNumberFormat: d3.format(',.2f')
});

RowChartStacked.propTypes = process.env.NODE_ENV !== "production" ? {
  /** A Crossfilter dimension made that returns an array key, e.g. crossfilter.dimension(d=>[d.key, d.key2, ..., d.keyN]).
   * The first element in the array will be the top level of the hierarchy */
  dimension: PropTypes.object.isRequired,

  /** A Crossfilter group made on the same dimension */
  group: PropTypes.object.isRequired,

  /** Either an array of colors or a function that accepts a value and returns a color */
  colors: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),

  /** Title to render on the chart */
  chartTitle: PropTypes.string,

  /** Width of diagram in pixels */
  width: PropTypes.number,

  /** Height of diagram in pixels */
  height: PropTypes.number,

  /** Render data labels in the diagram */
  renderLabel: PropTypes.bool,

  /** Render SVG:title tag, i.e. "tooltip" labels when holding the mouse above a rectangle */
  renderTitle: PropTypes.bool,

  /** Function to access the value */
  valueAccessor: PropTypes.func,

  /** Tile functions, one of d3.tilemap... functions  */
  tile: PropTypes.func,

  /** Margins object {top, bottom, left, right} */
  margins: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.number)]),

  /** Stack ordering function */
  stackOrder: PropTypes.func,

  /** Sub stack ordering function */
  subStackOrder: PropTypes.func,

  /** Gap between bars as a fraction of the bar width */
  gap: PropTypes.number,

  /** Set to render SVG legends */
  showLegend: PropTypes.bool,
  // Number of columns to layout the legend in
  legendCols: PropTypes.number,

  /** Height of legend */
  legendHeight: PropTypes.number,

  /** Height of individual legend item */
  legendItemHeight: PropTypes.number,

  /** Gap between legend items */
  legendItemGap: PropTypes.number,

  /** Shape of legend item symbol */
  legendItemSymbol: PropTypes.oneOf(['rect', 'circle']),

  /** Label number format  */
  labelNumberFormat: PropTypes.func
} : {};
export default RowChartStacked;